import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {isOpenInEditorVisible} from '../services/app-type-detector';
import ReviewStars from '../components/Review-stars';
import PricingAppBox from '../components/Pricing-app-box';
import AddToSiteButton from '../components/Add-to-site-button';
import {getIfAppIsInstalledPromise} from '../services/wrapped-app-market-sdk';
import {addAppClientData, openEditorApp} from '../services/app-flow';
import {cdnResize} from '../services/utils';
import {appEventStore, execBI} from '../services/bi-events-manager';
import classNames from 'classnames';
import ErrorMessage from '../components/Error-message';
import AppPageTabs from './App-page-tabs';
import ALink from './ALink';

const appTabs = [
  {url: 'overview', name: 'overview'},
  {url: 'demo', name: 'demo', hide: (app) => !app.liveDemoUrl},
  {url: 'features', name: 'features', hide: (app) => !app.features || !app.features.length},
  {url: 'reviews', name: 'reviews'},
  {url: 'developer', name: 'developer-info', hide: (app) => !app.developerInfo}
];

const getTabNameTranslate = function (tabId, app) {
  const key = 'application.tabs.' + tabId + '.name';
  return tabId === 'features' && !app.hasPremium ? `${key}Alternative` : key;
};


const handleOpenInEditor = (app, biPosition = 0) => {
  return ev => {
    ev.preventDefault();
    openEditorApp(app, biPosition);
  };
};


class AppPageHeader extends React.Component {

  componentDidMount() {
    getIfAppIsInstalledPromise({appDefinitionId: this.props.app.appDefinitionId, includingDemoMode: true})
      .then(isInstalled => this.setState({app: addAppClientData(this.props.app, isInstalled), loaded: true}))
      .catch(() => this.setState({app: addAppClientData(this.props.app, false), loaded: true}));
  }

  render() {
    const {reviews, urlPath} = this.props;
    const state = this.state || {};
    const app = state.app || this.props.app;

    return (
      <div className={classNames('app-header section-pad', {'app-page-loading': !state.loaded})}>
        <div className="app-logo">
          <img src={cdnResize(app.roundIcon || app.appIcon, 60, 60)} width="60" height="60" alt={`${app.name} by ${app.by} || WIX App Market`}/>
        </div>

        <div className="app-page-title">
          <div className="app-title">
            <h1 className="app-title-text">{app.name}</h1>
            <span className="app-producer typography_t4_1">
              <FormattedMessage id="application.by"/>
              {app.companyWebsite ?
                <a href={app.companyWebsite} target="_blank" rel="noopener" onClick={() => execBI('APP_MODAL_DEV_NAME_CLICK', {origin: 'header'})}> {app.by}</a> :
                <a onClick={() => execBI('APP_MODAL_DEV_NAME_CLICK', {origin: 'header'})}> {app.by}</a> }
            </span>
          </div>

          <div className="app-ratings">
            {app.isInstalled ?
              <div className="application-status-circle typography_t3_1">
                <span className="application-status-installed-ico"></span>
                <div className="application-status-installed"><FormattedMessage id="application.status.installed"/>
                </div>
              </div> :
              <div className="stats-app-box">
                <ALink to={`${urlPath}${app.slug}/reviews`}>
                  <ReviewStars reviews={reviews} showText/>
                </ALink>
              </div>}
          </div>
        </div>

        <div className="app-page-action">
          {isOpenInEditorVisible(app) ?
            <div className="secondary">
              <div className="app-action app-action-toggle">
                <a href="#" className="button-secondary" onClick={handleOpenInEditor(app, appEventStore.lastAppClickedPosition)}><FormattedMessage id="application.action.open"/></a>
              </div>
            </div> : null}

          <div className="app-action">
            <div className="app-action-loader">
              <div className="circle-loader circle-loader-smaller"></div>
              <div className="app-action-toggle">
                <AddToSiteButton app={app} biPosition={appEventStore.lastAppClickedPosition} primaryStyle/>
              </div>
            </div>
            <div className="app-pricing">
              <PricingAppBox app={app}/>
            </div>
          </div>
        </div>
      </div>
    );
  }

  static propTypes = {
    app: PropTypes.object.isRequired,
    reviews: PropTypes.object,
    urlPath: PropTypes.string
  }
}


export default class AppPage extends React.Component {
  render() {
    const app = this.props.app;
    const tabUrl = this.props.tabUrl || 'overview';
    const urlPath = this.props.isModal ? '/app-modal/' : '/';
    const names = {
      'app-page-popup': !this.props.isModal,
      'app-page-modal': this.props.isModal
    };

    return (
      <div className={classNames({'app-page-spacing': !this.props.isModal})}>
        <div className={classNames('app-page', names)}>

          {app.appDefinitionId ?
            <div>
              <AppPageHeader app={app} reviews={this.props.reviews} urlPath={urlPath}/>
              <div className="app-tabs section-pad">
                <ul className="app-tabs-ul">
                  {appTabs
                    .filter(tab => !tab.hide || !tab.hide(app))
                    .map(tab =>
                      <li key={tab.name} className="nav-tab typography_t1_1">
                        <ALink to={`${urlPath}${app.slug}/${this.props.isModal && tab.url === 'overview' ? '' : tab.url}`}
                              className="nav-tab-link" activeClassName="nav-tab-link-active"
                              onClick={() => execBI('APP_MODAL_TAB_CLICK', {tabId: tab.name})}
                              >
                          <FormattedMessage id={getTabNameTranslate(tab.name, app)}/>
                        </ALink>
                      </li>
                    )}
                </ul>
              </div>
              <AppPageTabs app={app} tabUrl={tabUrl}/>
            </div> :

            <div>
              {!app.appDefinitionId && !this.props.isError ?
                <div className="circle-loader"></div> : null}

              {this.props.isError ? <ErrorMessage/> : null}
            </div> }

        </div>
      </div>
    );
  }

  static propTypes = {
    app: PropTypes.object.isRequired,
    reviews: PropTypes.object,
    tabUrl: PropTypes.string,
    isModal: PropTypes.bool,
    isError: PropTypes.bool
  }
}



// WEBPACK FOOTER //
// ./components/App-page.js